import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { UserAssociation } from '../models';
import { Store } from '@ngxs/store';
import { AccountState } from '@state/account/state';
import { DOCUMENT } from '@angular/common';
import { generateDownloadableFile } from '@shared/functions';
import { FileFormat } from '@shared/enums';
import moment from 'moment';

@Injectable()
export class UserAssociationService {
  private httpClient = inject(HttpClient);
  private store = inject(Store);
  private docRef = inject(DOCUMENT);

  update(entity: UserAssociation): Observable<UserAssociation> {
    return this.httpClient.put<UserAssociation>(
      `accounts/${entity.related_to_id}/user_associations/${entity.id}?user_id=${entity.user.id}`,
      { user_association: entity },
    );
  }

  export(): Observable<null> {
    return this.httpClient
      .get<{
        data: string;
      }>(`accounts/${this.store.selectSnapshot(AccountState.getAccountId)}/user_associations/export`)
      .pipe(
        tap(({ data }) => {
          const subdomain = this.store.selectSnapshot(AccountState.getAccount).subdomain ?? '';
          const filename = `${subdomain}-users-${moment().format('YYYY-MM-DD')}.csv`;

          generateDownloadableFile(data, FileFormat.CSV, filename);
        }),
        map(() => null),
      );
  }
}
